import { CommonModule } from '@angular/common';
import { Component, inject, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [
    MatDialogTitle, MatDialogContent, MatButtonModule, MatDialogActions, MatDialogClose, MatIconModule, TranslatePipe, CommonModule,
  ],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss',
})
export class DialogComponent {
  data = inject<{
    title: string;
    iconSvg?: string;
    materialIcon?: string;
    body: string;
    yesBtnText?: string;
    yesBtnColor?: string;
    noBtnText?: string;
    noBtnColor?: string;
    confirmation?:boolean;
    dialogContent?: TemplateRef<void>;
    dialogActions?: TemplateRef<void>;
  }>(MAT_DIALOG_DATA);
}
